import { render, staticRenderFns } from "./UserBatchActions.vue?vue&type=template&id=bfcf88ca&scoped=true&"
import script from "./UserBatchActions.vue?vue&type=script&lang=js&"
export * from "./UserBatchActions.vue?vue&type=script&lang=js&"
import style0 from "./UserBatchActions.vue?vue&type=style&index=0&id=bfcf88ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfcf88ca",
  null
  
)

export default component.exports